(function () {
  'use strict';

  var observer = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionAvailable = true;

  function revealImmediately(elements) {
    elements.forEach(function (element) {
      element.classList.add('is-visible');
    });
  }

  function applyStagger(root) {
    root.querySelectorAll('[data-bao-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, index) {
        if (!child.hasAttribute('data-bao-reveal')) return;
        child.style.setProperty('--bao-reveal-delay', Math.min(index * 90, 320) + 'ms');
      });
    });
  }

  function bindHorizontalTracks(root) {
    root.querySelectorAll('[data-bao-horizontal-track]:not([data-bao-horizontal-bound])').forEach(function (track) {
      track.setAttribute('data-bao-horizontal-bound', 'true');
      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var card = track.firstElementChild;
        if (!card || track.scrollWidth <= track.clientWidth) return;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        event.preventDefault();
        track.scrollBy({
          left: event.key === 'ArrowRight' ? step : -step,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      });

      var section = track.closest('section');
      var progress = section && section.querySelector('[data-bao-carousel-progress]');
      if (!progress) return;

      var current = progress.querySelector('[data-bao-carousel-current]');
      var total = progress.querySelector('[data-bao-carousel-total]');
      var frame = null;

      function syncProgress() {
        frame = null;
        var cards = track.children;
        var count = cards.length;
        if (!count) return;
        var card = cards[0];
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var step = card.getBoundingClientRect().width + gap;
        var index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
        index = Math.max(0, Math.min(index, count - 1));
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        if (total) total.textContent = String(count).padStart(2, '0');
        progress.style.setProperty('--bao-carousel-progress', (index + 1) / count);
      }

      function requestProgressSync() {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(syncProgress);
      }

      track.addEventListener('scroll', requestProgressSync, { passive: true });
      window.addEventListener('resize', requestProgressSync, { passive: true });
      syncProgress();
    });
  }

  function observe(root) {
    var scope = root || document;
    var elements = Array.prototype.slice.call(scope.querySelectorAll('[data-bao-reveal]:not([data-bao-motion-bound])'));
    if (scope.nodeType === 1 && scope.matches('[data-bao-reveal]:not([data-bao-motion-bound])')) {
      elements.unshift(scope);
    }

    applyStagger(scope);

    elements.forEach(function (element) {
      element.setAttribute('data-bao-motion-bound', 'true');
    });

    if (!elements.length) return;
    if (reduceMotion || !motionAvailable || !('IntersectionObserver' in window)) {
      revealImmediately(elements);
      return;
    }

    if (!observer) {
      try {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.14,
          rootMargin: '0px 0px -8% 0px'
        });
      } catch (error) {
        motionAvailable = false;
        document.documentElement.classList.remove('bao-motion-ready');
        revealImmediately(Array.prototype.slice.call(document.querySelectorAll('[data-bao-reveal]')));
        return;
      }
    }

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function init(root) {
    var scope = root || document;
    bindHorizontalTracks(scope);
    if (reduceMotion) {
      document.documentElement.classList.add('bao-motion-reduced');
      observe(scope);
      return;
    }

    document.documentElement.classList.add('bao-motion-ready');
    observe(scope);
  }

  function boot() {
    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
